import { buildMonitoringInterceptor } from '@breathelife/monitoring-common';

import { logger } from './';

export const monitoringInterceptor = buildMonitoringInterceptor(logger.warn, logger.error);
